function sectionDetector(selector, margin) {

    let fixedDiv = document.querySelector('.c-cta');
    let sectionToObserve = document.querySelectorAll(selector);

    let observer = new IntersectionObserver(function (entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                fixedDiv.classList.add('js-isActive');
            } else {
                fixedDiv.classList.remove('js-isActive');
            }
        });
    }, {
        threshold: .5,
        rootMargin: margin
    });

    sectionToObserve.forEach(observeEl => observer.observe(observeEl))
}

document.addEventListener("DOMContentLoaded", function () {
    sectionDetector('.js-background1', '0px 0px 0px 0px');
    sectionDetector('.js-background2', "-120px 0px -120px 0px");
    sectionDetector('.js-background4', "-120px 0px -120px 0px");

    if (window.innerWidth < 1600) {
        sectionDetector('.js-background3', "-120px 0px -120px 0px");
    }

    $(window).resize(function () {
        if (window.innerWidth > 0 && window.innerWidth < 1600) {
            sectionDetector('.js-background3', "-120px 0px -120px 0px");
        }
    })
});
